import Core from "./Core"
import List from "./List"

export default {
  namespaced: true,
  modules: {
    Core,
    List
  }
}
